export default __webpack_public_path__ + "static/media/3726_124746.3b04be8b.svg";